import React from 'react';
import IconSystem from 'icon-collection/icon-systems';
import { ModuleHeader } from 'components/modals';
import ApprovalInbox from '../components/ApprovalInbox';

const ApprovalInboxScreen: React.FC = () => {
  return (
    <div className="module-master-container">
      <ModuleHeader
        title="Approval Inbox"
        description="Pending approvals across all workflows where your role is the named approver."
        icon={<IconSystem.checkCircle size={18} />}
      />
      <div className="module-content" style={{ marginTop: '6px', overflow: 'auto' }}>
        <ApprovalInbox />
      </div>
    </div>
  );
};

export default ApprovalInboxScreen;
